import { HttpClient, HttpParams } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { Router } from "@angular/router";
import { CookieService } from "ngx-cookie-service";
import { Observable } from "rxjs";
import { catchError, map } from "rxjs/operators";
import { AnnotationImageDetail, AnnotationObjectForUpdate } from "../../_objects/inspection-image-annotation";
import { HttpService } from "../http.service";
import { AnnotationImageContractService } from "../interfaces/annotation-image-contract.service";

@Injectable({
  providedIn: "root"
})
export class AnnotationImageOnlineService extends HttpService implements AnnotationImageContractService {
  constructor(
    private http: HttpClient,
    private cookieService: CookieService,
    private router: Router
  ) {
    super();
    super.setCookieService(cookieService);
    super.setHttpClient(http);
    super.setRouter(router);
  }

  // /api/v1/inspections/{inspectionId}/images/{inspectionImageId}/annotation
  getImageAnnotations(inspectionId: string, inspectionImageId: string): Observable<AnnotationImageDetail> {
    const endpoint = super.getEndpoint("inspections", inspectionId, "images", inspectionImageId, "annotation");

    return this.http
      .get<AnnotationImageDetail>(endpoint, { withCredentials: super.getWithCredentialsOption() })
      .pipe(map((response) => response as AnnotationImageDetail));
  }

  // /api/v1/inspections/{inspectionId}/images/{inspectionImageId}/annotation
  putImageAnnotations(updateAnnotation: AnnotationObjectForUpdate, inspectionId: string, usedImageMode: number): Observable<AnnotationImageDetail> {
    const endpoint = super.getEndpoint("inspections", inspectionId, "images", updateAnnotation.id, "annotation");

    updateAnnotation.usedImageMode = usedImageMode;

    return this.http
      .put<AnnotationImageDetail>(endpoint, updateAnnotation, { withCredentials: super.getWithCredentialsOption(), params: new HttpParams() })
      .pipe(map((response) => response as AnnotationImageDetail));
  }

  // /api/v1/inspections/{inspectionId}/images/{inspectionImageId}/annotation/upload
  putModifiedImage(inspectionId: string, inspectionImageId: string, file: File, usedImageMode?: number): Observable<AnnotationImageDetail> {
    const formData = new FormData();
    formData.append("file", file, file.name);

    let httpParams = new HttpParams();
    httpParams = httpParams.set("usedImageMode", usedImageMode.toString());

    const endpoint = super.getEndpoint("inspections", inspectionId, "images", inspectionImageId, "annotation", "upload");

    return this.http
      .put<AnnotationImageDetail>(endpoint, formData, {
        withCredentials: super.getWithCredentialsOption(),
        reportProgress: true,
        params: httpParams
      })
      .pipe(map((response) => response as AnnotationImageDetail));
  }
}
